import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom"
import keycloak from "./keycloak.js";
import './App.css';
import MainView from './components/MainView/MainView.jsx';
//import OrderCreation from "./components/OrderCreator/OrderCreator.js";
import OrdersView from "./components/OrdersView/OrdersView.jsx";
import ExportsView from "./components/ExportsView/ExportsView.jsx";
import ProvidersView from "./components/ProvidersView/ProvidersView.jsx";
import ProfileView from "./components/ProfileView/ProfileView.jsx";
import LoginView from "./components/LoginView/LoginView.jsx";
import CollectionsView from "./components/CollectionsView/CollectionsView.jsx";
import { useDispatch } from "react-redux";
import { getCollections } from "./services/collections.service.jsx";
import { getProviders, getStorageEndpoints } from "./services/provider.service.jsx";
import { USE_KEYCLOAK } from "./common/utils/apiService.jsx";
import { Loader } from "rsuite";


function App() {

  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);


  const dispatch = useDispatch();

  useEffect(() => {
    if (!USE_KEYCLOAK) {
      setIsAuthenticated(true);
      setLoading(false);
      return;
    }
  
    keycloak
      .init({
        onLoad: 'login-required',
        checkLoginIframe: false,
      })
      .then((authenticated) => {
        if (authenticated) {
          setIsAuthenticated(true);
        } else {
          keycloak.login({ redirectUri: "/" });
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error('Keycloak initialization error:', error);
        setLoading(false);
      });
  }, []);
  

  useEffect(() => {
    if (isAuthenticated) {
      dispatch(getCollections());
      dispatch(getProviders());
      dispatch(getStorageEndpoints());
    }
  }, [isAuthenticated, dispatch]);

  const ProtectedRoute = ({ element }) => {
    return isAuthenticated ? element : <Navigate to="/" />;
  };


  if (loading) {
    return <div><Loader inverse center content="loading, please wait..." /></div>; // Show loading while Keycloak initializes
  }

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route
            path='/'
            element={<ProtectedRoute element={<MainView />} />}
          />
          {/* <Route
            path="/login"
            element={<ProtectedRoute element={<LoginView />} />}
          /> */}
          <Route
            path="/collections"
            element={<ProtectedRoute element={<CollectionsView />} />}
          />
          <Route
            path="/orders"
            element={<ProtectedRoute element={<OrdersView />} />}
          />
          {/* <Route
            path="/createOrder"
            element={isAuthenticated ? <OrderCreation /> : <Navigate to="/login" />}
          /> */}
          <Route
            path="/providers"
            element={<ProtectedRoute element={<ProvidersView />} />}
          />
          <Route
            path="/profile"
            element={<ProtectedRoute element={<ProfileView />} />}
          />
          <Route
            path="/downloads"
            element={<ProtectedRoute element={<ExportsView />} />}
          />
          <Route
          path="/login"
          element={<ProtectedRoute element={<LoginView />} />}
          />
          {/* <Route
            path="/workspaces"
            element={isAuthenticated ? <WorkspacesView /> : <Navigate to="/login" />}
          /> */}
          <Route
            path="*"
            element={<ProtectedRoute element={<h3>Route Not Configured</h3>} />}
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
